import { render, staticRenderFns } from "./Guia.vue?vue&type=template&id=b7ca12de&lang=pug&"
import script from "./Guia.vue?vue&type=script&lang=js&"
export * from "./Guia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports